import { useTranslation } from '@pascal/pascal-core';
import { TKeys } from '../../core/constants/TKeys';

export const HelpPopup = () => {
  const t = useTranslation()
  const info = new Array(9).fill(null).map((elem,index) => {
    return <p className="popup-info-txt" key={index}>{t(`${TKeys.GameRules}${index+1}`)}</p>
  })
  return (
    <div className="info-popup-wrp">
      {info}
    </div>
  );
};